import type { CoffeeBean, DrinkCategory, MenuItem, OrderOptions, OrderSelection } from "./types";

export const drinkCategoryOrder: DrinkCategory[] = ["嚴選咖啡", "義式特調", "經典特調", "純粹茶飲"];

export const coffeeBeans: CoffeeBean[] = [
  { id: "scene-01", name: "Scene 01／櫻桃配方", origin: "哥倫比亞、衣索比亞、哥斯大黎加", process: "水洗", roast: "中焙", flavor: "橙皮、牛奶糖、堅果、可可" },
  { id: "scene-02", name: "Scene 02／白花甜荔", origin: "衣索比亞", process: "水洗", roast: "淺中焙", flavor: "白花、荔枝、桃子、烏龍茶" },
  { id: "scene-03", name: "Scene 03／神隱莊園", origin: "尼加拉瓜", process: "水洗", roast: "淺中焙", flavor: "葡萄皮、柑橘、杏仁" },
  { id: "scene-04", name: "Scene 04／貝多芬", origin: "哥斯大黎加", process: "酵素水洗", roast: "淺中焙", flavor: "草莓、西瓜、青葡萄、檸檬" },
  { id: "scene-05", name: "Scene 05／莫札特", origin: "哥斯大黎加", process: "葡萄乾蜜處理", roast: "淺中焙", flavor: "草莓、玫瑰、甜果香" },
  { id: "scene-06", name: "Scene 06／巴哈", origin: "哥斯大黎加", process: "葡萄乾蜜處理", roast: "淺中焙", flavor: "草莓、檸檬、蘋果、葡萄" },
];

const image = (path: string) => `/images/menu/${path}`;
export const sauceOptions = ["起司醬", "松露醬"] as const;
const main = (id: string, name: string, price: number, filename: string, sortOrder: number, description = "", dietaryTags: string[] = [], sauces?: Array<(typeof sauceOptions)[number]>): MenuItem => ({
  id, kind: "main", category: "主食", name, price, description, dietaryTags,
  imageUrl: image(`main/${filename}`), options: sauces ? { sauces } : {}, active: true, sortOrder,
});
const drink = (id: string, category: MenuItem["category"], name: string, folder: string, filename: string, sortOrder: number, temperatures: Array<"冰" | "熱">, sweetness?: Array<"無糖" | "微糖">, beans?: CoffeeBean[]): MenuItem => ({
  id, kind: "drink", category, name, price: 0, description: "", dietaryTags: [],
  imageUrl: image(`drinks/${folder}/${filename}`),
  options: { temperatures, ...(sweetness ? { sweetness } : {}), ...(beans ? { coffeeBeans: beans } : {}) },
  active: true, sortOrder,
});

const breakfast = {
  sausage: "奶油吐司、培根片、德式香腸、絲滑起司蛋、蛋沙拉、鳳梨水果優格、季節水果",
  chicken: "奶油吐司、煙燻雞肉、絲滑起司蛋、蛋沙拉、鳳梨水果優格、季節水果",
  veggie: "奶油吐司、炸薯塊、絲滑起司蛋、蛋沙拉、鳳梨水果優格、季節水果",
};

export const initialMenu: MenuItem[] = [
  main("main-chicken-plate", "燻雞厚蛋餐盤", 190, "燻雞厚蛋餐盤.png", 1, breakfast.chicken),
  main("main-veggie-plate", "田園蔬食餐盤", 190, "田園蔬食餐盤.png", 2, breakfast.veggie, ["蛋奶素"]),
  main("main-beef-lasagna", "蕃茄燉牛千層麵", 180, "蕃茄燉牛千層麵.png", 3),
  main("main-chicken-lasagna", "奶油嫩雞千層麵", 180, "奶油嫩雞千層麵.png", 4),
  main("main-karaage", "酥脆唐揚炸雞", 160, "酥脆唐揚雞.png", 5, "", [], [...sauceOptions]),

  drink("drink-coffee-americano", "嚴選咖啡", "美式咖啡", "coffee", "美式咖啡.png", 101, ["冰", "熱"], undefined, coffeeBeans),
  drink("drink-coffee-latte", "嚴選咖啡", "經典拿鐵", "coffee", "經典拿鐵.png", 102, ["冰", "熱"], undefined, coffeeBeans),
  drink("drink-italian-watermelon", "義式特調", "冰萃西瓜美式", "italian", "冰萃西瓜美式.png", 201, ["冰"]),
  drink("drink-italian-sicilian", "義式特調", "清檸柚香西西里", "italian", "清檸柚香西西里.png", 202, ["冰"]),
  drink("drink-italian-mocha", "義式特調", "濃潤可可摩卡", "italian", "濃潤可可摩卡.png", 203, ["冰", "熱"]),
  drink("drink-italian-hazelnut", "義式特調", "烤糖榛果拿鐵", "italian", "烤糖榛果拿鐵.png", 204, ["冰", "熱"]),
  drink("drink-classic-cocoa", "經典特調", "濃潤可可歐蕾", "classic", "濃潤可可歐蕾.png", 301, ["冰", "熱"]),
  drink("drink-classic-watermelon", "經典特調", "蜜蘋西瓜烏龍", "classic", "蜜蘋西瓜烏龍.png", 302, ["冰"]),
  drink("drink-tea-peach", "純粹茶飲", "春映桃花紅茶", "tea", "春映桃花紅.png", 401, ["冰", "熱"], ["無糖", "微糖"]),
  drink("drink-tea-honey", "純粹茶飲", "金麥蜂釀綠茶", "tea", "金麥蜂釀綠.png", 402, ["冰", "熱"], ["無糖", "微糖"]),
];

export function defaultOptionsForItem(item: MenuItem): OrderOptions {
  return {
    ...(item.options.sauces?.length === 1 ? { sauce: item.options.sauces[0] } : {}),
    ...(item.options.temperatures?.length === 1 ? { temperature: item.options.temperatures[0] } : {}),
    ...(item.options.sweetness?.length === 1 ? { sweetness: item.options.sweetness[0] } : {}),
    ...(item.options.coffeeBeans?.length === 1 ? { coffeeBeanId: item.options.coffeeBeans[0].id } : {}),
  };
}

export function itemNeedsOptionDialog(item: MenuItem): boolean {
  return Boolean(
    (item.options.sauces && item.options.sauces.length > 1)
    || (item.options.temperatures && item.options.temperatures.length > 1)
    || (item.options.sweetness && item.options.sweetness.length > 1)
    || (item.options.coffeeBeans && item.options.coffeeBeans.length > 1),
  );
}

export function validateItemOptions(item: MenuItem, options: OrderOptions): string[] {
  const errors: string[] = [];
  const { sauces, temperatures, sweetness, coffeeBeans: beans } = item.options;
  if (sauces && (!options.sauce || !sauces.includes(options.sauce))) errors.push("請選擇醬料");
  if (temperatures && (!options.temperature || !temperatures.includes(options.temperature))) errors.push("請選擇有效的冰熱選項");
  if (sweetness && (!options.sweetness || !sweetness.includes(options.sweetness))) errors.push("請選擇有效的甜度");
  if (beans && (!options.coffeeBeanId || !beans.some((bean) => bean.id === options.coffeeBeanId))) errors.push("請選擇咖啡豆");
  return errors;
}

export function validateOrderSelection(selection: OrderSelection, menu: MenuItem[] = initialMenu): string[] {
  const errors: string[] = [];
  const mainItem = menu.find((item) => item.id === selection.mainItemId && item.kind === "main" && item.active);
  const drinkItem = menu.find((item) => item.id === selection.drinkItemId && item.kind === "drink" && item.active);
  if (!mainItem) errors.push("請選擇有效的主食");
  if (mainItem) errors.push(...validateItemOptions(mainItem, selection.options));
  if (!drinkItem) return [...errors, "請選擇有效的飲品"];
  errors.push(...validateItemOptions(drinkItem, selection.options));
  return errors;
}

export function getOrderTotal(selection: OrderSelection, menu: MenuItem[] = initialMenu): number {
  return menu.find((item) => item.id === selection.mainItemId && item.kind === "main")?.price ?? 0;
}
